import styled from 'styled-components'

import { Cores } from '../styles'

export const Container = styled.div`
  width: 471px;
  background: ${Cores.BRANCO};
  border: 1px solid ${Cores.BRANCO};
  box-sizing: border-box;
  border-radius: 4px;
  padding: 70px 30px;

  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Icone = styled.div`
  margin-bottom: 24px;
`

export const Titulo = styled.h5`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 30px;
  line-height: 35px;
  text-align: center;
`

export const Corpo = styled.div`
  display: flex;
  margin-top: 30px;
  margin-bottom: 30px;

  p {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 140%;
  }
`

export const Acoes = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  .btn-acao-modal-secundaria {
    margin-right: 24px;
  }
`
